export default __webpack_public_path__ + "static/Timothea-Horwell-01fa2cb3d2ac6384ffb74937692e20e8.png";